import React from 'react';
import PropTypes from 'prop-types';
import styles from './methods.module.scss';
import PhosphorIcon from '../icons/PhosphorIcon';

const Methods = ({showForm}) => (
  <ul className={styles.Methods}>
    <li className={styles.Methods__method}>
      <a
        href="https://app.teamgantt.com/book-a-demo?ref=helpdocs"
        target="_blank"
      >
        <div className={styles.Methods__icon}>
          <PhosphorIcon name="calendarCheck" size={22} />
        </div>
        <div className={styles.Methods__text}>
          <h4>Schedule live help</h4>
          <p>Book a call with one of our friendly experts.</p>
        </div>
      </a>
    </li>
    <li className={styles.Methods__method}>
      <a href="#" onClick={showForm}>
        <div className={styles.Methods__icon}>
          <PhosphorIcon name="chatCircleText" size={22} />
        </div>
        <div className={styles.Methods__text}>
          <h4>Send us a message</h4>
          <p>We love your feedback and hearing what you have to say!</p>
        </div>
      </a>
    </li>
  </ul>
);

Methods.propTypes = {
  showForm: PropTypes.func.isRequired,
};

export default Methods;



// WEBPACK FOOTER //
// ./src/components/contact/Methods.js